import React from 'react';
import c from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { Delete } from '@lyearn/icons';
import { Box, Typography } from '@lyearn/ui';

import { deleteButtonStyles, editButtonStyles, linkStyles } from './styles';

const ViewLink = ({
  href,
  onEditClick,
  onDelete,
}: {
  href: string;
  onEditClick: () => void;
  onDelete: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <a
        className={c('mx-12 overflow-x-auto whitespace-nowrap', linkStyles)}
        href={href}
        rel="noreferrer"
        target="_blank">
        <Typography className="border-none text-link-01 underline" variant="body-short-02">
          {href}
        </Typography>
      </a>
      <Box className="h-24 w-1 bg-border" />
      <Box
        className={c(
          'mx-4 cursor-pointer rounded-4 py-4 px-8 hover:bg-interactive-white-hover',
          editButtonStyles,
        )}
        role="button"
        onClick={onEditClick}>
        <Typography className="edit" color="text-text-placeholder" variant="heading-xxs">
          {t('Common:Actions.Edit')}
        </Typography>
      </Box>
      <Box className="h-24 w-1 bg-border" />
      <Box
        className={c(
          'mx-4 cursor-pointer rounded-4 py-4 px-8 hover:bg-bg-error-light',
          deleteButtonStyles,
        )}
        role="button"
        onClick={onDelete}>
        <Delete className="delete h-20 w-20 text-icon-secondary" />
      </Box>
    </>
  );
};

export default ViewLink;
